import "./Corporate.module.css";
import Header from "@/reusable_sections/Header";
import WhyPartnersChooseUs from "./sections/WhyPartnersChooseUs";
import GetYourBlueprint from "./sections/GetYourBlueprint";
import Footer from "@/reusable_sections/Footer";
export default function CorporatePage() {
  return <div>
      <Header />
      <WhyPartnersChooseUs />
      <GetYourBlueprint />
      <Footer />
    </div>;
}